import { FlowEntry, FlowProgressWithSteps, FlowRoute } from 'utils/FlowProvider/types'

export const NavSteps: (entry: FlowEntry, props: any) => FlowProgressWithSteps = (
  entry,
  { visitedPages, history },
) => {
  if (!entry) {
    history.push(FlowRoute.Welcome, { pageNotFound: true })
  }
  return { ...entry.progress, steps: [] }
}
